enum JobWorkerOfferStatus {
	Pending = 5,
	SentToContact = 10,
	ContactDeclined = 15,
	ContactConfirmed = 18,
	SentToWorker = 20,
	WorkerDeclined = 25,
	WorkerAccepted = 28,
	Placed = 90,
	Cancelled = 100 
}

export default JobWorkerOfferStatus;